
import AppConfigurationPage from '.';

export default {
    appConfigurationPage: {
        path: '/app-configuration',
        title: 'App Configuration',
        auth: true,
        component: AppConfigurationPage,
        // permission: [apiConfig.news.getList.baseURL],
    },
};
